import { action } from 'easy-peasy';
import { IActionSetSuperAdmin } from '../types';

const setSuperAdmin: IActionSetSuperAdmin = action((state, payload) => {
  state.current = payload;
});

export default setSuperAdmin;
